import CustomSelect from '../../../components/CustomSelect';
import MutipleSelection from '../../../components/CustomSelect/MutipleSelection';
import { STATUS_CLINIC, CLINIC_LOCATION_STATUS } from '../constants';
import { handleSelectAll } from '@/helpers';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import { Box } from '@material-ui/core';
import { ArtTrackOutlined } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';

const SearchClinic = (props) => {
  const [statusOpen, setStatusOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState([]);
  const renderValue = (array, label, defaultLabel) => {
    let value = '';
    if (array.length === 0) value = defaultLabel;
    else if (array.length === 1) value = array[0];
    else value = `${label} (${array.length})`;

    return value;
  };

  // return (
  //   <CustomSelect
  //     onClick={() => setStatusOpen(!statusOpen)}
  //     clearable={!isEmpty(setStatusFilter)}
  //     onClear={() => {
  //       setStatusFilter([]);
  //       props.onSearch({ clinicStatus: [] });
  //     }}
  //     prefixIcon={
  //       <ArtTrackOutlined
  //         style={{
  //           fontSize: 20,
  //           color: '#E9E9E9',
  //           marginRight: 8
  //         }}
  //       />
  //     }
  //     renderValue={<>{statusFilter.join(', ') || 'Select Status'}</>}
  //   >
  //     <MutipleSelection
  //       value={statusFilter}
  //       data={STATUS_CLINIC}
  //       open={statusOpen}
  //       onChange={e => {
  //         props.onSearch({ clinicStatus: e.target.value });
  //         setStatusFilter(e.target.value);
  //       }}
  //     />
  //   </CustomSelect>
  // );
  return (
    <Box width={300} mt={2.5}>
      <CustomSelectContainer
        isFullWidth
        height="40px"
        filterValue={statusFilter || []}
        data={CLINIC_LOCATION_STATUS}
        renderValue={renderValue(
          statusFilter.map(
            (it) => CLINIC_LOCATION_STATUS.find((item) => item.key === it).value
          ),
          'Statuses',
          'All statuses'
        )}
        clearable={false}
        onChange={(e) => {
          let value = e.target.value;

          value = handleSelectAll(
            value,
            CLINIC_LOCATION_STATUS.map((item) => item.key),
            statusFilter
          );
          setStatusFilter(value);
          props.onSearch({ clinicStatus: value });
        }}
        labelSelectAll={'All statuses'}
        useSelectAll
        checkedAll={CLINIC_LOCATION_STATUS.length === statusFilter.length}
      />
    </Box>
  );
};

export default SearchClinic;
